// 稳定路由身份；命名规则见 _READ_ME/路由标识规范.md。
export const ROUTE = Object.freeze({
  shopInventory: 'inventory.shop', // 本店库存：查询与人工记账。
  replenishment: 'inventory.replenishment', // 补货计划：本店上下限、草稿与 Excel。
  headquartersInventory: 'inventory.headquarters', // 总部独立库存。
  branchInventory: 'inventory.branches', // 分店当前库存，只读。
  blank: 'app.blank', // 空白页面：切换工作门店时的空白过渡页。
  checkout: 'sales.checkout', // 开单收款：商品开单与收款。
  tables: 'sales.tables', // 桌台点单：桌台点单与结账。
  pending: 'sales.pending', // 取回挂单：取回暂存订单继续收银。
  orders: 'sales.orders', // 历史订单：订单查询与后续处理。
  preorders: 'sales.preorders', // 商品预订：商品预订单与定金管理。
  calendar: 'appointments.calendar', // 预约服务：服务预约日历。
  appointments: 'appointments.orders', // 服务预约单：服务预约单管理。
  customers: 'members.customers', // 会员资料：会员资料和资产查询。
  recharge: 'members.recharge', // 售卡充值：会员购卡充值，复用开单页。
  dailyReport: 'reports.daily', // 日结报表：门店日结统计。
  incomeReport: 'reports.income', // 营收报表：门店营收统计。
  cashReport: 'reports.cash', // 收款报表：门店收款统计。
  shopHome: 'shop.home', // 本店首页：顾客端门店首页内容管理。
  shopGoods: 'shop.goods', // 本店定价：本店上架商品与价格管理。
  preorderSettings: 'shop.preorders', // 预订设置：门店商品预订设置。
  shopTables: 'shop.tables', // 桌台管理：门店桌台资料管理。
  shifts: 'appointments.shifts', // 预约班次：预约服务班次配置。
  receiptFormats: 'shop.receipts', // 门店票据格式。
  settings: 'shop.settings', // 常用设置：门店常用设置。
  printers: 'device.printers', // 打印机设置：Electron 本机用途、测试和配置。
  chainIncome: 'chain.income', // 营收总表：总部跨店营收汇总。
  chainCash: 'chain.cash', // 收款总表：总部跨店收款汇总。
  chainProfile: 'chain.profile', // 商户资料：商户资料及注销。
  shops: 'chain.shops', // 开通分店：商户分店开通与管理。
  accounts: 'chain.accounts', // 收款账户：商户收款账户配置。
  levels: 'members.levels', // 会员等级：会员等级规则配置。
  staff: 'staff.directory', // 员工资料：商户员工资料及工作范围管理。
  types: 'catalog.types', // 大类：商品大类管理。
  categories: 'catalog.categories', // 小类：商品小类管理。
  specs: 'catalog.specs', // 商品规格：商品规格配置。
  labels: 'catalog.labels', // 商品标签：商品标签配置。
  goods: 'catalog.goods', // 商品：商户实物商品资料。
  coupons: 'catalog.coupons', // 制作卡券：商户卡券商品制作。
  services: 'catalog.services', // 服务：商户服务商品资料。
  register: 'auth.register', // 注册商户：商户注册入口。
  login: 'auth.login', // 扫码登录：恢复登录态并进入统一登录流程。
  registerCallback: 'auth.registercallback', // 注册回调：微信商户注册回调。
  staffCallback: 'auth.staffcallback', // 添加员工回调：微信加入员工回调。
});
